import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { SUBFOLDERS_TYPES } from '../../../pages/virtualOffice/shared/enums/documents-subfolders';

const MarketingContactPage = lazy(() => import('../../../pages/').then((module) => ({ default: module.MarketingContactPage })));
const ProductSheetsPage = lazy(() => import('../../../pages/').then((module) => ({ default: module.FormsDocuments })));
const FormsList = lazy(() => import('../../../pages/').then((module) => ({ default: module.FormsDocuments })));
const ContactIndexPage = lazy(() => import('../../../pages/').then((module) => ({ default: module.ContactIndex })));
const ProductManualsPage = lazy(() => import('../../../pages/').then((module) => ({ default: module.FormsDocuments })));
const NotesPage = lazy(() => import('../../../pages/').then((module) => ({ default: module.FormsDocuments })));
const SSNResolutionsPage = lazy(() => import('../../../pages/').then((module) => ({ default: module.FormsDocuments })));
const BrochureCaution = lazy(() => import('../../../pages/').then((module) => ({ default: module.FormsDocuments })));

const TutorialsPage = lazy(() => import('../../../pages/virtualOffice/Tutorials/components').then((module) => ({ default: module.Tutorials })));

export const virtualOfficeChildrenRoutes = [
    {
      path: 'tutoriales',
      element: <TutorialsPage title="Tutoriales" />,
    },
  {
    path: 'marketing',
    element: <MarketingContactPage title='Marketing - ¿En que podemos ayudarte?' />,
  },
  {
    path: 'fichas-productos',
    element: <ProductSheetsPage title="Fichas Productos" subFolder={SUBFOLDERS_TYPES.PRODUCT_SHEETS} />,
  },
  {
    path: 'formularios',
    element: <FormsList title="Formularios" subFolder={SUBFOLDERS_TYPES.FORMS} />,
  },
  {
    path: 'indice-contactos',
    element: <ContactIndexPage title="Índice de Contactos" subFolder={SUBFOLDERS_TYPES.CONTACT_INDEX} />,
  },
  {
    path: 'manuales-producto',
    element: <ProductManualsPage title="Manuales Producto" subFolder={SUBFOLDERS_TYPES.PRODUCT_MANUALS} />,
  },
  {
    path: 'notas-red',
    element: <NotesPage title="Notas Red" subFolder={SUBFOLDERS_TYPES.NOTES} />,
  },
  {
    path: 'resolucion-ssn',
    element: <SSNResolutionsPage title="Resolución SSN" subFolder={SUBFOLDERS_TYPES.SSN_RESOLUTIONS} />,
  },
    {
    path: 'brochure-seguro-caucion',
    element: <BrochureCaution title="Brochure Seguro de Caución" subFolder={SUBFOLDERS_TYPES.BROCHURE_CAUTION} />,
  },
];
